export const environment = {
  production: true,
  envName: 'Production',
  loadBalanced: true,
  // servers: ['aglpwatssl01.amer.dell.com', 'aglpwatssl02.amer.dell.com'],
  servers: ['aglpwlvssl01.amer.dell.com', 'aglpwlvssl02.amer.dell.com'],
  agileAPIs: {
    virusscan: {
      getRequest: 'https://agileattachmentutility.us.dell.com/api/agile/scan/',
    },

    AgileFileDelete: {
      postRequest:
        'https://agileattachmentutility.us.dell.com/api/agile/deletefile',
    },

    agileupload: {
      postRequest:
        'https://agileattachmentutility.us.dell.com/api/agile/upload/',
    },

    agiledownload: {
      postRequest:
        'https://agileattachmentutility.us.dell.com/api/agile/download/',
    },

    agileItemAttachments: {
      getRequest:
        'https://agileattachmentutility.us.dell.com/api/agile/attachmentinfo',
    },
    validateUserSession: {
      getRequest:
        'https://agileattachmentutility.us.dell.com/api/agile/userValidation',
    },
    validateUserSessionREST: {
      getRequest:
        'https://agileattachmentutility.us.dell.com/api/agile/ValidateUser',
    },

    OSLangInfo: {
      getRequest:
        'https://agileattachmentutility.us.dell.com/api/agile/osvalues/',
    },
    OSLangUpdate: {
      postRequest:
        'https://agileattachmentutility.us.dell.com/api/agile/oslangupdate/',
    },
    getUserSessionInfo: {
      getRequest:
        'https://agileattachmentutility.us.dell.com/api/agile/validate/usersession',
    },
    getUserPrivilegeInfo: {
      getRequest:
        'https://agileattachmentutility.us.dell.com/api/agile/userprivilege',
    },

    fileTypeCodes: {
      getRequest:
        'https://agileattachmentutility.us.dell.com/api/agile/filetypecodes',
    },
    AgileUploadFromServer: {
      postRequest:
        'https://agileattachmentutility.us.dell.com/api/agile/uploadfile',
    },
    AgileDownloadToUNC: {
      postRequest:
        'https://agileattachmentutility.us.dell.com/api/agile/downloadfile',
    },
    AgileFileReplace: {
      postRequest:
        'https://agileattachmentutility.us.dell.com/api/agile/replacefile',
    },
    downloadZipFIleService: {
      postRequest:
        'https://agileattachmentutility.us.dell.com/api/agile/download',
    },
    fileCacheWithoutAcc: {
      postRequest:
        'https://agileattachmentutility.us.dell.com/api/agile/cachefile',
    },
    updateHardwareRelMapping: {
      postRequest:
        'https://agileattachmentutility.us.dell.com/api/agile/relmappingupdate',
    },
    getItemAttributes: {
      getRequest:
        'https://agileattachmentutility.us.dell.com/api/agile/iteminfo/',
    },
    getUserGuidesList: {
      getRequest:
        'https://agileattachmentutility.us.dell.com/api/agile/userguideslist',
    },
    downloadUserGuide: {
      postRequest:
        'https://agileattachmentutility.us.dell.com/api/agile/downloadguide',
    },
    checkRemoteFile: {
      getRequest:
        'https://agileattachmentutility.us.dell.com/api/agile/remotefilecheck',
    },
    validateAgileSession: {
      getRequest:
        'https://agileattachmentutility.us.dell.com/api/agile/validateAgileSession',
    },
  },
  avScanApis: {
    SubmitForScan: {
      postRequest:
        'https://agilessl.us.dell.com/antivirus/scan/',
    },
    SubmitForScanV2: {
      postRequest:
        'https://agilessl.us.dell.com/antivirus/scanv2/',
    },
    GetScanResponse: {
      getRequest:
        'https://agilessl.us.dell.com/antivirus/scanresponse/',
    },
  },
  fileCatalystApis: {
    connectResource: {
      getRequest: 'http://127.0.0.1:12680/rs/agent/connect',
      checkConnection:
        'http://127.0.0.1:12680/rs/agent/connect/connectivityTest/',
      postRequest: 'http://127.0.0.1:12680/rs/agent/connect',
    },

    localResource: {
      getRequest: 'http://127.0.0.1:12680/rs/files/local/',
    },

    statusResource: {
      getRequest: 'http://127.0.0.1:12680/rs/agent/status/',
    },

    transferRev1Resource: {
      postRequest:
        'http://127.0.0.1:12680/rs/files/transferRev1',
      getRequest_cancel:
        'http://127.0.0.1:12680/rs/files/transferRev1/cancel/',
    },
    heartBeatResource: {
      getRequest: 'http://127.0.0.1:12680/rs/agent/heartbeat',
    },
    remoteResource: {
      getRequest: 'http://127.0.0.1:12680/rs/files/remote/',
    },
    remoteFilesResource: {
      getRequest:
        'http://127.0.0.1:12680/rs/files/remotefile/',
    },
    userDetailsResource: {
      getRequest:
        'http://127.0.0.1:12680/rs/agent/userDetails',
    }
  },

  userUploadsDirectory: 'user_uploads',
};
